import React, { Fragment } from "react";
import { Button, InputAdornment, Popover, TextField } from "@material-ui/core";
import RBIAutocomplete from "../RBIAutocomplete/RBIAutocomplete";
import RBIAutocompleteSearch from "../RBIAutocompleteSearch/RBIAutocompleteSearch";
import { isUndefined } from "../../utils/utils";
import SearchIcon from "@material-ui/icons/Search";

import styles from "./styles";
import { useTranslation } from "react-i18next";

interface RBISearchButtonInterface {
  onChange: any;
  onChangeInput?: any;
  handleApplyButton: Function;
  handleOnClosePopUp?: any;
  valueOption: any;
  id: string;
  width?: number;
  labelText: string;
  options?: any[];
  freeSolo?: boolean;
  textButton?: string;
  noOptions?: boolean;
}

const RBISearchButton = ({
                           labelText,
                           onChange,
                           onChangeInput = () => {},
                           handleApplyButton,
                           handleOnClosePopUp,
                           valueOption,
                           id,
                           freeSolo = false,
                           options = [],
                           width = 180,
                           textButton = '',
                           noOptions = false,
                         }: RBISearchButtonInterface) => {
  const classes = styles();
  const [
    anchorElPopover,
    setAnchorElPopover,
  ] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
      event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    setAnchorElPopover(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorElPopover(null);
    handleOnClosePopUp && handleOnClosePopUp();
  };

  const onApplyButton = () => {
    handleApplyButton();
    handlePopoverClose();
  };
  const markup = (onChangeInput, noOptions) => {
    let markup: JSX.Element;
    if (isUndefined(onChangeInput) && !noOptions) {
      markup = (
          <RBIAutocomplete
              onChangeInput={onChange}
              value={valueOption}
              id={id}
              freeSolo={freeSolo}
              label={labelText}
              width={width}
              options={options}
          />
      );
    } else if (noOptions) {
      markup = (
        <>
          <TextField
            style={{ width }}
            label={labelText}
            variant="outlined"
            margin="normal"
            name={id}
            value={valueOption}
            autoFocus
            onChange={onChange}
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {' '}
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </>
      );
    } else {
      markup = (
        <RBIAutocompleteSearch
          onChange={onChange}
          onChangeInput={onChangeInput}
          value={valueOption}
          id={id}
          label={labelText}
          width={width}
          options={options}
        />
      );
    }
    return markup;
  };

  const { t } = useTranslation();

  return (
    <Fragment>
      <TextField
        value={valueOption?.name || valueOption || '' }
        placeholder={labelText}
        onClick={handlePopoverOpen}
        classes={{
          root: classes.textFieldStyle,
        }}
        size="small"
        variant="outlined"
        InputProps={{
          endAdornment: <SearchIcon />,
        }}
      />
      <Popover
        open={Boolean(anchorElPopover)}
        onClose={handlePopoverClose}
        anchorEl={anchorElPopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{
          paper: `${classes.searchButtonPopover} `,
        }}
      >
        <div className={`${classes.flexSpaceBetween} ${classes.alignCenter}`}>
          {markup(onChangeInput, noOptions)}
          <Button
            className={classes.buttonApply}
            size="small"
            variant="contained"
            color="primary"
            onClick={onApplyButton}
          >
            {textButton || t('app.common.filter')}
          </Button>
        </div>
      </Popover>
    </Fragment>
  );
};

export default RBISearchButton;
